import { getContentSerie } from 'services/api/content/serie';
import RequestManager from '../requests/RequestManager';
import DataTask from '../requests/tasks/card/DataTask';
import PreDownload from '../requests/tasks/card/preDownload';
import PurchaseButtonTask from '../requests/tasks/card/PurchaseButtonTask';
import RecomendationsTask from '../requests/tasks/card/RecomendationsTask';
import { GetRegion } from '../constants';
import '../utils/concatAll';
import { purchaseButtonInfoService } from 'api/services/payway';
import { getRegion } from 'utils/Region';

export const CONST_SET_SERIES = 'set_series';
export const CONST_SET_CONTENT_DATA = 'set_content_data';
export const GET_DOWNLOAD = 'get_download';
export const CONST_SET_PURCHASE_INFO = 'set_purchase_info';
export const CONST_SET_PURCHASE_INFO_SUSC = 'set_purchase_info_susc';
export const CONST_SET_RECOMENDATIONS_DATA = 'set_recomendations_data';
export const CONST_SET_PIN = 'set_pin';
export const SET_WIDTH = 'set_width';
export const SET_CONTENT_TITLE = 'set_content_title';
export const SET_CONTENT_DESCRIPTION = 'set_content_description';
export const GET_EPISODE_CONTENT = 'get_episode_content';
export const SET_ERR_FICHA = 'set_err_ficha';
export const SET_ERR_DOWNLOAD = 'set_err_download';

export const setSeries = seriesData => ({ type: CONST_SET_SERIES, seriesData });
export const setContentData = contentData => ({
  type: CONST_SET_CONTENT_DATA,
  contentData,
});
export const getDownload = download => ({ type: GET_DOWNLOAD, download });
export const setPurchaseInfo = purchaseInfo => ({
  type: CONST_SET_PURCHASE_INFO,
  purchaseInfo,
});
export const setPurchaseInfoSusc = purchaseInfoSusc => ({
  type: CONST_SET_PURCHASE_INFO_SUSC,
  purchaseInfoSusc,
});
export const setRecomendationsData = recomendationsData => ({
  type: CONST_SET_RECOMENDATIONS_DATA,
  recomendationsData,
});
export const setPin = pin => ({ type: CONST_SET_PIN, pin });
export const setwidth = width => ({ type: SET_WIDTH, width });
export const setErrorFicha = errorData => ({ type: SET_ERR_FICHA, errorData });
export const setErrorDownload = errorData => ({
  type: SET_ERR_DOWNLOAD,
  errorData,
});

export const getEpisodeContent = episodeId => (dispatch, getState) => {
  const { seriesData } = getState().card;
  const episodeInfo = seriesData
    .map(season => season.episodes)
    .concatAll()
    .filter(episode => episode.id == episodeId)
    .pop();
};

export const fetchSeries = (groupId, userHash) => async dispatch => {
  const params = {
    group_id: groupId,
    user_hash: userHash,
  };

  const data = await getContentSerie(params);
  if (data.status === '0') {
    const { seasons } = data.response;
    dispatch(setSeries(seasons));
  }
};

export const fetchContentData = (config, groupId, userHash) => dispatch => {
  const dataRequest = new DataTask(config, {
    group_id: groupId,
    user_hash: userHash,
    region: GetRegion(),
  });
  RequestManager.addRequest(dataRequest)
    .then(data => {
      if (data.isSerie) {
        dispatch(fetchSeries(groupId, userHash));
      } else {
        dispatch(setSeries(null));
      }
      dispatch(setContentData(data));
    })
    .catch(e => {
      console.log('ERR_NO_CONTENT_DATA');
      dispatch(setErrorFicha(e.message ? { message: e.message } : true));
    });
};

export const fetchPurchaseSusc = config => async (dispatch, getState) => {
  const claroAdEnable =
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.[
      getRegion()
    ]?.enable ||
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.default
      ?.enable;
  await purchaseButtonInfoService({
    object_type: 'A',
    claroAdEnable: claroAdEnable,
  })
    .then(({ data }) => {
      dispatch(setPurchaseInfoSusc(data.response));
    })
    .catch(e => {
      console.log('ERR_NO_PURCHASE_BUTTON');
    });
};

export const fetchRecomendationsData = (
  config,
  groupId,
  filterId,
) => dispatch => {
  const dataRequest = new RecomendationsTask(config, {
    group_id: groupId,
    filterlist: filterId,
  });
  RequestManager.addRequest(dataRequest)
    .then(data => {
      dispatch(setRecomendationsData(data));
    })
    .catch(e => {
      console.log('ERR_NO_RECOMENDATIONS');
    });
};

export const setWidth = width => dispatch => {
  dispatch(setwidth(width));
};

export const fetchDownload = (config, args, groupId, cb) => dispatch => {
  const dataRequest = new PreDownload(config, {
    group_id: groupId,
    content_id: args.content_id,
    quality: args.quality,
    dubsub: args.dubsub,
    user_hash: args.user_hash,
    img: args.img,
    authpn: config.authpn,
    authpt: config.authpt,
  });

  RequestManager.addRequest(dataRequest)
    .then(data => {
      if (cb) cb(data);
      return dispatch(getDownload(data));
    })
    .catch(e => {
      // console.log('ERR_DOWNLOAD');
      if (cb) cb(e);
      dispatch(setErrorDownload(e));
    });
};
